import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { RouterModule } from '@angular/router';
import { SharedModule } from 'projects/shared/src/lib/shared';
import { SidebarService } from 'projects/shared/src/lib/shared/services/local/side-bar.service';

import { BaseLayoutComponent } from './base-layout.component';

@NgModule({
    imports: [
        SharedModule,

        MatIconModule,

        MatSelectModule,

        RouterModule
    ],
    declarations: [
        BaseLayoutComponent
    ],
    providers: [SidebarService]
})
export class BaseLayoutModule { }